export const generatePassword = () => {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789@#$!';
  return Array.from({ length: 12 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
};

export const inputSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    fontSize: '14px',
    height: '45px',
    backgroundColor: '#F8FAFC',
    '& fieldset': { borderColor: '#DEE5EE' },
    '&:hover fieldset': { borderColor: '#385576' },
    '&.Mui-focused fieldset': { borderColor: '#007BC6', borderWidth: '1.5px' },
  },
  '& input': { color: '#1A1A2E', fontWeight: 600 },
  '& input::placeholder': {
    color: '#8397AE', opacity: 1, fontSize: '14px', fontWeight: 600,
  },
};
